import { useMemo, useState, useRef, useCallback, useContext, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ServiceContext } from "../../../contexts/ServiceContext";
import { AppAlert } from "../../../utils/AppAlert";
import { ReactComponent as DescriptionIcon } from "../../../icons/description.svg";
import { ReactComponent as BatteryIcon } from "../../../icons/battery.svg";
import { ReactComponent as OfflineIcon } from "../../../icons/offline.svg";
import { ReactComponent as CompanyIcon } from "../../../icons/company.svg";
import { ReactComponent as OnlineIcon } from "../../../icons/online.svg";
import { ReactComponent as AlarmIcon } from "../../../icons/alarm.svg";
import { ReactComponent as DateIcon } from "../../../icons/date.svg";
import { ReactComponent as GpsIcon } from "../../../icons/gps.svg";
import { ReactComponent as EditIcon } from "../../../icons/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../icons/delete.svg";
import { ReactComponent as DetailsIcon } from "../../../icons/details.svg";
import { ReactComponent as MenuIcon } from "../../../icons/menu.svg";
import { ReactComponent as EmailsMenuIcon } from "../../../icons/email-menu.svg";
import { ReactComponent as DevicesMenuIcon } from "../../../icons/devices-menu.svg";
import { ReactComponent as UsersMenuIcon } from "../../../icons/users-menu.svg";
import { ReactComponent as CompaniesMenuIcon } from "../../../icons/company-menu.svg";
import { ReactComponent as MessagesMenuIcon } from "../../../icons/messages-menu.svg";
import { ReactComponent as PhoneNumberMenuIcon } from "../../../icons/phone-number-menu.svg";
import { ReactComponent as ConfirmPhoneNumberIcon } from "../../../icons/confirmPhoneNumber.svg";
import { ReactComponent as Error } from "../../../icons/x-circle.svg";
import { ReactComponent as Ok } from "../../../icons/check-circle.svg";
import { ConfirmPhoneNumber } from '../../common' ;
import Select from "react-select";
import config from "../../../config";
import "./devices.css";

function Devices() {
const [searchParams, setSearchParams] = useSearchParams();
const [open, setOpen] = useState(true);
const [menu, setMenu] = useState(null);
const [isOpen, setIsOpen] = useState(false);
const menuDevicesRef = useRef(null);
const [selectedItemId, setSelectedItemId] = useState(0);
const [companies, setCompanies] = useState([]);
const [devices, setDevices] = useState([]);
const [actions, setActions] = useState([]);
const [triggers, setTriggers] = useState([]);
const [loading, setLoading] = useState(true);
const [availableCompanies, setAvailableCompanies] = useState("");
const [availableUsers, setAvailableUsers] = useState("");
const [availableDevices, setAvailableDevices] = useState("");
const [emailNotifications, setAvailableEmailNotifications] = useState("");
const [messagesNotifications, setAvailablemMssagesNotifications] = useState("");
const [phoneCallsNotifications, setAvailablePhoneCallsNotifications] = useState("");
const {infrastructureService, dataService, notificationService} = useContext(ServiceContext);
const [filter, setFilter] = useState(searchParams.get("filter") || "");
const [companyId, setCompanyId] = useState(searchParams.get("companyId") || "");  
const [currentPage, setCurrentPage] = useState(Number(searchParams.get("currentPage")) || 1);
const [totalPages, setTotalPages] = useState(1);
const userRole = localStorage.getItem("user_role");
const Global_Admin_Role = "Global Admin";
const [phoneNumber, setPhoneNumber] = useState("");
const [phoneNumberConfirmed, setPhoneNumberConfirmed] = useState(false);
let updatedIds;
const itemsPerPage = config.uiSettings.itemsPerPage || 20;
const [isOpenCompanies, setIsOpenCompanies] = useState(false);
const [targetCompanyId, setTargetCompanyId] = useState(null);
const [moveDeviceId, setMoveDeviceId] = useState(null);

async function saveClick() {
  try {
    await infrastructureService.patch("Device/move", {
      id: moveDeviceId,
      targetCompanyId: targetCompanyId
    });

    setIsOpenCompanies(false);
    loadDevices();
  } catch (error) {
    console.error(error);
  }
}

const navigate = useNavigate();

 const repeatHoldTimeMinutesList = useMemo(
    () => [
      { id: 1, name: "Do not repeat", value: 0 },
      { id: 3, name: "30 minutes", value: 30 },
      { id: 4, name: "1 hour", value: 60 },
      { id: 5, name: "2 hours", value: 120 },
      { id: 6, name: "4 hours", value: 240 },
      { id: 7, name: "8 hours", value: 480 },
      { id: 8, name: "16 hours", value: 960 },
      { id: 9, name: "24 hours", value: 1440 },
    ],
    [] 
  );

const companyOptions = [
  { value: "all", label: "Select all companies" },
  ...companies.map((c) => ({
    value: String(c.id),  
    label: c.name
  }))
];
  
const handlePageChange = (p) => {
  setCurrentPage(p);
  setSearchParams({ids: (updatedIds || []).join(","),  companyId: companyId, filter: filter, currentPage: p});
};

const handleLeftClick = (e, id) => {
    e.stopPropagation();
    const clickX = e.clientX;
    const clickY = e.clientY;
    const screenW = window.innerWidth;
    const screenH = window.innerHeight;

    const menuW = 120; 
    const menuH = menuDevicesRef.current ? menuDevicesRef.current.offsetHeight : 120;

    let posX = clickX;
    let posY = clickY;
    
    if (clickX + menuW > screenW) {
      posX = screenW - menuW - 5;
    }
    
    if (clickY + menuH > screenH) {
      posY = screenH - menuH - 5;
    }

    setMenu({ x: posX, y: posY, id });
};

const handleChange = (e) => {
  setFilter(e.target.value);
  setCurrentPage(1);
};

const handleBlur = (e) => {
  setSearchParams({ids: (updatedIds || []).join(","), companyId: companyId, filter: e.target.value, currentPage: 1});
};

const handleCompanyChange = (selectedOption) => {
  setCurrentPage(1);
  if (selectedOption.value === "all") {
    setCompanyId("");
    setSearchParams({ids: (updatedIds || []).join(","), companyId: "", filter: filter, currentPage: 1});
  } else {
    setCompanyId(selectedOption?.value || null);
    setSearchParams({ids: (updatedIds || []).join(","), companyId: selectedOption?.value || null, filter: filter, currentPage: 1});
  }
};

const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "#f5f5f5",
      borderColor: state.isFocused ? "#c7c4c4ff" : "#ccc",
      boxShadow: state.isFocused ? "0 0 0 2px #b1aeaeff" : "none",
      "&:hover": { borderColor: "#3f3f3fff" },
      borderRadius: "8px",
      padding: "2px 4px",
      minHeight: "42px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#525050"
        : state.isFocused
        ? "#ebe8e8ff"
        : "white",
      color: state.isSelected ? "white" : "#525050",
      padding: "10px 15px",
      cursor: "pointer",
      fontWeight: state.isSelected ? "bold" : "normal",
      transition: "background-color 0.1s ease",
      ":active": {
        backgroundColor: "#525050",
        color : "white"
      }
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#888",
      fontStyle: "italic"
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#222"
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: state.isFocused ? "#3f3f3fff" : "#999",
      "&:hover": { color: "#3f3f3fff" }
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "8px",
      overflow: "hidden",
      marginTop: "4px",
      boxShadow: "0 4px 12px #525050"
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0
    })
  };  

const loadTriggers = useCallback(async () => {
    try {
      setLoading(true);
      let getTriggers = {
        fromIndex: 0,
        itemsCount: config.uiSettings.itemsPerPage
      };
      const data = await notificationService.get("Triggers", getTriggers); 
      setTriggers(data.items);
    } catch (error) {
      console.error("Error fetching triggers:", error);
    } finally {
      setLoading(false);
    }
  }, [notificationService]);

  const loadActions = useCallback(async () => {
    try {
      setLoading(true);
      let getActions = {
        fromIndex: 0,
        itemsCount: config.uiSettings.itemsPerPage
      };
      const data = await notificationService.get("Actions", getActions); 
      setActions(data.items);
    } catch (error) {
      console.error("Error fetching actions:", error);
    } finally {
      setLoading(false);
    }
  }, [notificationService]);

    
  const loadCompanies = useCallback(async () => {
  try {
    setLoading(true);
    let getCompanies = {
      filter: "",
      showBlocked: false,
      fromIndex: 0,
      itemsCount: ""
    };
     const data = await infrastructureService.get("Companies", getCompanies); 
     setCompanies(data.items);
  } catch (error) {
     console.error("Error fetching companies:", error);
  } finally {
    setLoading(false);
  }
}, [infrastructureService]);

const loadDevices = useCallback(async () => {
  try {
    let getDevices = {
      filter: filter,
      fromIndex: (currentPage - 1) * itemsPerPage,
      companyId: companyId,
      itemsCount: itemsPerPage
    };
     const data = await infrastructureService.get("Devices", getDevices); 
     setDevices(data.items);
     setTotalPages(Math.ceil(data.totalItemsCount / itemsPerPage));
  } catch (error) {
     console.error("Error fetching devices:", error);
  } finally {
    setLoading(false);
  }
}, [infrastructureService, filter, companyId, currentPage, itemsPerPage]);

const loadStatisticSummary = useCallback(async () => {
  try {
    setLoading(true);
     const data = await infrastructureService.get("Statistic"); 
     setAvailableCompanies(data.availableCompanies);
     setAvailableDevices(data.availableDevices);
     setAvailableUsers(data.availableUsers);
     setAvailableEmailNotifications(data.emailNotifications);
     setAvailablemMssagesNotifications(data.smsNotifications);
     setAvailablePhoneCallsNotifications(data.phoneCallsNotifications);
  } catch (error) {
     console.error("Error fetching statistic summary:", error);
  } finally {
    setLoading(false);
  }
}, [infrastructureService]);
 
const fetchUser =  useCallback(async () =>  {
        const token = localStorage.getItem("access_token");
        const userId = getUserIdFromToken(token);
        if (!userId) {
          return;
        }
  
        try {
          const data = await infrastructureService.get("User", { userId });
          setPhoneNumber(data.phoneNumber);
          setPhoneNumberConfirmed(data.phoneNumberConfirmed);
        } catch (error) {
          console.error("Error fetching user:", error);
        } finally {
          setLoading(false);
        }
  }, [infrastructureService]);

  const getUserIdFromToken = (token) => {
    if (!token) return null;
    try {
      const payload = token.split(".")[1];
      const decoded = JSON.parse(atob(payload));
      return decoded.user_id || null;
    } catch (e) {
      console.error("Invalid token:", e);
      return null;
    }
  };

useEffect(() => {
  const newFilter = searchParams.get("filter") || "";
  const newCompanyId = searchParams.get("companyId") || "";
  const newCurrentPage = Number(searchParams.get("currentPage")) || 1;
  setFilter(newFilter);
  setCompanyId(newCompanyId);
  setCurrentPage(newCurrentPage);
}, [searchParams]);

useEffect(() => {
  loadCompanies();
  loadActions();
  loadTriggers();
  loadStatisticSummary();
  fetchUser();
}, [loadCompanies, loadStatisticSummary, loadActions, loadTriggers, fetchUser]);

useEffect(() => {
    const handleClickOutside = (e) => {
    if (
      menuDevicesRef.current &&
      !menuDevicesRef.current.contains(e.target) &&
      !e.target.closest(".menu-trigger") 
    ) {
      setMenu(null);
    }
  };
  document.addEventListener("click", handleClickOutside);
  return () => document.removeEventListener("click", handleClickOutside);
}, []);

useEffect(() => {
    loadDevices();
}, [loadDevices]);
   
  function NotificationCard({ deviceId }) {
    const [selectedId, setSelectedId] = useState(1);
    const [ruleId, setRuleId] = useState(0);
    const [hiddenButtons, setHiddenButtons] = useState(true);
    const [selectedActions, setSelectedActions] = useState([]);
    const [selectedTriggers, setSelectedTriggers] = useState([]);
    const [isOpenConfirm, setIsOpenConfirm] = useState(false);

      useEffect(() => {const loadRule = async () => {
        try {
             let getRule = {
               deviceId: deviceId
             };
             const data = await notificationService.get("Rule", getRule); 
             setRuleId(data.id);
             setSelectedId(repeatHoldTimeMinutesList.find(item => item.value === data.repeatHoldTimeInterval)?.id ?? 1);
             setSelectedActions(data.ruleActions.map(item => item.actionTypeId));
             setSelectedTriggers(data.ruleTriggers.map(item => item.triggerTypeId));
          } catch (error) {
               console.error("Error fetching rule:", error);
          }
        };
        loadRule();
     }, [deviceId]);

      async function cancelClick() {
        setHiddenButtons(true);
        const loadRule = async () => {
        try {
             let getRule = {
               deviceId: deviceId
             };
             const data = await notificationService.get("Rule", getRule); 
             setRuleId(data.id);
             setSelectedId(repeatHoldTimeMinutesList.find(item => item.value === data.repeatHoldTimeInterval)?.id  ?? 1);
             setSelectedActions(data.ruleActions.map(item => item.actionTypeId));
             setSelectedTriggers(data.ruleTriggers.map(item => item.triggerTypeId));
          } catch (error) {
               console.error("Error fetching rule:", error);
          }
        };
        loadRule();
      } 
      
      async function savelClick() {
        setLoading(true);
        let editRule = {
           id: ruleId,
           deviceId: deviceId,
           repeatHoldTimeInterval: repeatHoldTimeMinutesList.find(item => item.id === selectedId)?.value ?? 0,
           ruleActions: selectedActions.map(id => ({ id })),
           ruleTriggers: selectedTriggers.map(id => ({ id }))
        };
        try {
          await notificationService.post("Rule", editRule);
          AppAlert.success("Success! Changes have been applied.");
        } catch (err) {
           console.error(err);
        }
        setHiddenButtons(true);
        const loadRule = async () => {
        try {
             let getRule = {
               deviceId: deviceId
             };
             const data = await notificationService.get("Rule", getRule); 
             setRuleId(data.id);
             setSelectedId(repeatHoldTimeMinutesList.find(item => item.value === data.repeatHoldTimeMinutes)?.id  ?? 1);
             setSelectedActions(data.ruleActions.map(item => item.actionTypeId));
             setSelectedTriggers(data.ruleTriggers.map(item => item.triggerTypeId));
          } catch (error) {
               console.error("Error fetching rule:", error);
          }
        };
        loadRule();
        setLoading(false);
      }

      const handleChange = (e) => {
         setSelectedId(Number(e.target.value))
         setHiddenButtons(false);
      }; 
      
      const handleActionsToggle = (actionId) => {
        setSelectedActions((prev) =>
          prev.includes(actionId)
          ? prev.filter((id) => id !== actionId) 
          : [...prev, actionId] 
        );
        setHiddenButtons(false);
      };  
  
      const handleTriggersToggle = (triggerId) => {
        setSelectedTriggers((prev) =>
          prev.includes(triggerId)
          ? prev.filter((id) => id !== triggerId) 
          : [...prev, triggerId] 
        );
        setHiddenButtons(false); 
      };  

      async function confirmClick() {
        setIsOpenConfirm(true); 
      }  
      
     return (
      <div>
        <hr/>
               <div className="div-inline-100">
                  <label className="lab-bold" style={{paddingLeft: "5px"}}>Notifications</label>
               </div>
               <div className="div-inline-100"> 
                  <label>
                     <span className="span-bold" style={{paddingLeft: "5px"}}>Repeat Interval</span>
                     <span> : </span>
                     <span>
                        <select style={{ width: "200px" }} value={selectedId} onChange={handleChange}>
                                   {repeatHoldTimeMinutesList.map((item) => (
                                      <option key={item.id} value={item.id}>
                                        {item.name}
                                      </option>
                                    ))}
                        </select>
                     </span>
                  </label>
               </div>
               <div className="div-inline-100" style={{ textAlign:"start" }}>
                 <div style={{ float: "left", width: "300px" }}>
                     <label className="span-bold" style={{paddingLeft: "5px"}}>
                        Triggers:
                     </label><br/>
                    {triggers != null && triggers.length > 0 ? ( triggers.map((trigger) => { 
                      const inputId = "trigger" + trigger.id + deviceId;
                      return (
                        <label key={`trigger-${deviceId}-${trigger.id}`} style={{ whiteSpace: "nowrap" }}>
                          <label className="toggle-switch">
                            <input className="toggle-input" id={inputId} type="checkbox" 
                                   checked={selectedTriggers.includes(trigger.id)} 
                                   onChange={() => handleTriggersToggle(trigger.id)}/>
                            <label className="toggle-label" htmlFor={inputId}></label>
                            <span className="toggle-label-text">{trigger.name}</span>
                          </label><br />
                        </label>
                      );})
                      ) : (
                         <p>No triggers available.</p>
                      )}
                 </div>
                 <div style={{ float: "left", width: "300px"}}>
                    <label className="span-bold" style={{paddingLeft: "5px"}}>
                        <span> Actions: </span>
                    </label><br/>
                    {actions != null && actions.length > 0 ? ( actions.map((action) => { 
                      const inputId = "action" + action.id + deviceId;
                      return (
                        <label key={`action-${deviceId}-${action.id}`} style={{ whiteSpace: "nowrap" }}>
                          <label className="toggle-switch">
                            <input className="toggle-input" id={inputId} type="checkbox" 
                                   checked={selectedActions.includes(action.id)} 
                                   onChange={() => handleActionsToggle(action.id)}/>
                            <label className="toggle-label" htmlFor={inputId}></label>
                            <span className="toggle-label-text">{action.name}</span>
                          </label><br />
                        </label>
                      );})
                      ) : (
                         <p>No actions available.</p>
                      )}
                       {(selectedActions.includes(2) || selectedActions.includes(3)) && (
                           <div>
                             {(!phoneNumberConfirmed && phoneNumber !== null) &&(<div>
                              It appears that your phone number hasn't been confirmed yet, so we can’t call or send you SMS messages until you opt in. 
                              <div style={{ height: "30px",borderRadius:"8px",fontSize:"16px", width:"auto", maxWidth:"230px" }}
                                   className="cancel" onClick={confirmClick}>
                                <span style={{paddingTop:"7px", paddingRight:"5px", fontWeight:"bold"}}><ConfirmPhoneNumberIcon/></span>Confirm phone number
                              </div>
                            </div>)}
                            {(!phoneNumberConfirmed && phoneNumber === null) &&(<div>
                              It appears that your phone number hasn't been added.
                            </div>)}
                           </div>
                        )}
                 </div>
              </div> 
               {!hiddenButtons && (<div className="div-inline-100" style={{ textAlign:"start" }}>
                 <div style={{ float: "left", width: "300px" }}>
                    <div className="cancel" style={{ height: "30px",borderRadius:"8px",fontSize:"16px" }} onClick={cancelClick}>Cancel</div>
                 </div>
                 <div style={{ float: "left", width: "300px"}}>
                    <div className="submit" style={{ height: "30px",borderRadius:"8px",fontSize:"16px" }} onClick={savelClick}>Save changes</div>
                 </div>
               </div>)}
               <ConfirmPhoneNumber isOpenConfirm={isOpenConfirm} setIsOpenConfirm={setIsOpenConfirm} phoneNumber={phoneNumber} onConfirmed={handleConfirmChanged}/>
      </div>
     );
  }

  function DeviceInfoDetails({deviceId}){
    const [device, setDevice] = useState(false);
    const [status, setStatus] = useState(null);
    const [alarms, setAlarms] = useState(null);
    const [loadDevice, setLoadDevice] = useState(false);

    useEffect(() => { 
      const fetchDevice = async () => {
        try {
             setLoadDevice(true);
             const data = await infrastructureService.get(`Device?deviceId=${deviceId}`); 
             setDevice(data);
             setAlarms(data.lastAlarmInfo);
        } catch (error) {
          console.error("Error fetching device:", error);
        }
        finally{
          setLoadDevice(false);
        }
      };
      const loadStatus = async () => {
        try {
          const data = await dataService.get(`DeviceStatus?deviceId=${deviceId}`);
          setStatus(data);
        } catch (err) {}   
      };
      const loadAlarms = async () => {
        try {
          const data = await dataService.get(`DeviceAlarm?deviceId=${deviceId}`);
          setAlarms(data);
        } catch (err) {} 
      };
      fetchDevice();
      loadStatus();
      const intervalStatusId = setInterval(loadStatus, config.uiSettings.refreshTimeOfRequest);
      const intervalAlarmsId = setInterval(loadAlarms, config.uiSettings.refreshTimeOfRequest);
      return () => {
        clearInterval(intervalStatusId);
        clearInterval(intervalAlarmsId);
      };
    }, [deviceId]);

    const getChannelNameById = (id) =>
      device?.alarmChannels?.find(c => c.alarmChannelId === id)?.name || null;

    if (loadDevice) return <div>Loading...</div>;

    return(
      <div>
        <div className="div-inline-100">
          <label>
            <span className="lab-bold">Connection Status: </span>
            <span>
              {!device?.isOnline && <OfflineIcon />}
              {device?.isOnline && <OnlineIcon />}
            </span>
          </label>
        </div>  
         {!loadDevice && device?.alarmChannels !== null && (<div className="div-inline-100">
            <label>
              <label className="lab-bold">Channel Names: </label>  
              <span className="span-bold span-margin-left">CH1: </span>
              <span className="span-width-220">{getChannelNameById(1)}</span>
              <span className="span-bold span-margin-left">CH2: </span>
              <span className="span-width-220">{getChannelNameById(2)}</span>
              <br/>
              <span className="span-bold span-margin-left-120">CH3: </span>
              <span className="span-width-220">{getChannelNameById(3)}</span>
              <span className="span-bold span-margin-left-19">CH4: </span>
              <span className="span-width-220">{getChannelNameById(4)}</span>
            </label>
        </div>)}
        <hr/>
        <div className="div-inline-100" style={{ textAlign:"start" }}>
          <div style={{ float: "left", width: "300px" }}>
            <label className="lab-bold">
              Last Status
              <Link to={`/statuses/${deviceId}`} onClick={(e)=>e.stopPropagation()} style={{ paddingLeft: "110px" }}> 
                  <label className="link-lab">History</label>
              </Link>
            </label><br/>
            {status === null && <p>No check-ins available</p>}
            {status && (
              <div style={{minHeight: "150px"}}>
                <label>
                  <DateIcon/><span className="span-bold">Date-Time</span><span>: {status?.lastStatusMsgDatetimeUtc ? new Date(status.lastStatusMsgDatetimeUtc + "Z").toLocaleString() : "No Statuses available yet"}</span>
                </label><br/>
               {status.gpsCoordinate ? (
                <label>
                  <GpsIcon/><span className="span-bold">GPS: </span><span>
                    <a href={status.gpsCoordinate ? `http://www.google.com/maps/place/${status.gpsCoordinate.gpsLatitude.toFixed(6)},${status.gpsCoordinate.gpsLongitude.toFixed(6)}` : "#" } target="_blank" rel="noopener noreferrer">
                       {status.gpsCoordinate ? `${status.gpsCoordinate.gpsLatitude.toFixed(6)}, ${status.gpsCoordinate.gpsLongitude.toFixed(6)}` : "—"}</a></span>
                </label>
                ): (
                  <label><GpsIcon/><span className="span-bold">GPS</span><span>: No GPS available</span></label>
                )}<br/>
                <label>
                     <BatteryIcon />

                       {device.nextGeneration ? (
                          <>
                              <span className="span-bold">Power Mode</span>
                              <span>
                                : {status?.batteryStatus?.batteryOk ? "Normal" : "Low"}
                              </span>
                          </>
                       ) : (
                          <>
                              <span className="span-bold">Battery</span>
                              <span>
                                  : {status?.batteryStatus?.batteryOk ? "OK" : "Low"}
                              </span>
                          </>
                       )}
                </label><br/>
                {status.systemStatus ? (
                  <label>{status.systemStatus?.systemOk ? <Ok/> : <Error/>}<span className="span-bold">Unit Status</span>{status.systemStatus?.systemOk ? <span>: Ok</span> : <span style={{color: "red"}}>: Error</span>}
                   </label>
                   ): (<label><Error/><span className="span-bold">Unit Status</span><span>: No unit status available</span></label>)}
              </div>
            )}
          </div>
          <div style={{ float: "left", width: "300px"}}>
            <label className="lab-bold">
              Last Alarm
              <Link to={`/alarms/${deviceId}`} onClick={(e)=>e.stopPropagation()} style={{ paddingLeft: "110px" }}> 
                 <label className="link-lab">History</label>
              </Link>
            </label><br/>
            {alarms === null && <p>No alarms available</p>}
            {alarms && (<label>
              <label>
                <DateIcon/><span className="span-bold">Date-Time</span><span>: {alarms?.lastAlarmMsgDatetimeUtc ? new Date(alarms.lastAlarmMsgDatetimeUtc + "Z").toLocaleString() : "No Alarms available yet"}</span>
              </label><br/>
              {alarms?.alarms?.filter(a => a.status === true).length > 0 ? (
                alarms.alarms.filter(a => a.status === true).map(a => (
                  <label key={`alarm-${deviceId}-${a.id}`}>
                    <AlarmIcon /><span className="span-bold">{a.alarmChannelName}</span><span>: {a.deviceAlarmChannelName}</span>
                  <br />
                  </label>
                ))
            ) : (<p>No active alarms</p>)}
            </label>)}
          </div>
        </div>
      </div>
    );
  }
   
    function Device({ id, name, description, nextGeneration, companyid, activeAlarmCount, isOnline, serialNumber}) {
      const [openExpanderCard, setOpenExpanderCard] = useState(false);
      const [inputValue, setInputValue] = useState("");
      const isConfirmedDeleting = inputValue.toLowerCase() === "delete";
      
      useEffect(() => {
         const idsFromUrl = (searchParams.get("ids") || "").split(",").filter(Boolean).map(Number);
         setOpenExpanderCard(idsFromUrl.includes(id));
      }, [id]);

      const toggleCard = () => {
        const idsFromUrl = (searchParams.get("ids") || "").split(",").filter(Boolean).map(Number);       
        if (idsFromUrl.includes(id)) {
          updatedIds = idsFromUrl.filter(i => i !== id);
        } else {
           updatedIds = [...idsFromUrl, id];
        }
        setSearchParams({ ...Object.fromEntries(searchParams.entries()), ids: (updatedIds || []).join(","), companyId: companyId, filter: filter, currentPage: currentPage });
      };  

    return (
      <div className="card-border">
        <div className="card-div" onClick={toggleCard} >
          <div className="div-inline-50">
            <label>
              <span>
                {!isOnline && <OfflineIcon/>}
                {isOnline && <OnlineIcon/>}{"  "}
                <Link to={`/deviceInfo/${id}`} onClick={(e)=>e.stopPropagation()}>
                   {name}
                </Link>
              </span>
            </label>
          </div>
          <div className="div-inline-20">
            <label>
            </label>
          </div>
          <div className="div-inline-20">
            <label>
            </label>
          </div>
          <div className="div-inline-3" style={{minWidth: "55px"}}>
            {activeAlarmCount !== undefined && activeAlarmCount !== 0 && (<label>
             <AlarmIcon/><span>{activeAlarmCount}</span>
            </label>)}
          </div>
          <div className="div-inline-3">
            <svg  width="20" height="20" fill="currentColor" viewBox="0 0 16 16" onClick={(e) => handleLeftClick(e, id)}>
              <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/>
            </svg>
          {menu && menu.id === id && (
            <ul ref={menuDevicesRef}  onClick={() => setMenu(null)} className="context-menu" style={{ top: menu.y, left: menu.x, position: "fixed" }}>
              <li onClick={(e) => {  e.stopPropagation(); navigateToDeviceSettingsClick(id);}}>
                <label>
                  <EditIcon/> Edit
                </label>
              </li> 
              <li onClick={(e) => {  e.stopPropagation(); navigate("/deviceInfo/" + id);}}>
                <label>
                  <DetailsIcon/> Details
                </label>
              </li>
              {(userRole !== undefined && userRole === Global_Admin_Role) && (
                <li onClick={(e) => { setMoveDeviceId(id); setTargetCompanyId(companyid); setIsOpenCompanies(true); }}>
                  <label> 
                    <EditIcon/> Move
                  </label>
                </li>
              )}
              <li>
                <label onClick={(e) => { e.stopPropagation(); setSelectedItemId(id); deleteDeviceClick(); setMenu(null);}}>
                  <DeleteIcon/> Delete
                </label>                
              </li>
            </ul>
          )}
          </div>
          <div className="div-inline-3">
            <div className="open-expander-card">
            {openExpanderCard ? "▲" : "▼"}
          </div>
          </div>
        </div>
        <div className="cerd-div">
          {openExpanderCard && (
             <div className="card-div card-border-text">
                <div className="div-inline-100">
                   <label>
                    <DescriptionIcon/><span className="span-bold">ESN</span><span>: {serialNumber}</span>
                   </label><br/>
                   <label>
                     <DescriptionIcon />
                     <span className="span-bold">Type</span>
                     <span>: {nextGeneration ? "Next-Generation" : "Original"}</span>
                   </label><br />
                   <label>
                    <DescriptionIcon/><span className="span-bold">Description</span><span>: {description}</span>
                   </label><br/>
                   <label>
                     <CompanyIcon/><span className="span-bold">Company</span><span>: {companies?.find((c) => c.id === companyid)?.name || "—"}</span>
                   </label>
                </div>  
                <>
                  <DeviceInfoDetails deviceId={id}/>
                  <NotificationCard deviceId={id}/>
                </>          
             </div>
          )}
        </div>
        {isOpen && (
          <div style={{position: "fixed",top: 0,left: 0,right: 0,bottom: 0,display: "flex",justifyContent: "center",alignItems: "center",zIndex: 1000,}}> 
            <div style={{backgroundColor: "white",borderRadius: "8px",width: "300px",boxShadow: "0 5px 15px rgba(0,0,0,0.3)",textAlign:"start"}}>
              <div style={{background:"rgb(236, 236, 236)"}}>
                <h2 style={{ margin:"0px",padding:"13px 0px",textAlign:"center" }}>Delete device</h2>
              </div>
              <div style={{border: "solid rgb(236, 236, 236) 1px", padding:"10px"}}>
                <p style={{ marginBottom: "20px" }}>Do you want to delete the device? <br/><br/>Note: The device will be deleted without the possibility of restoration.</p>
                <p>To confirm deletion, enter <span style={{fontWeight:"600", fontStyle:"italic"}} className="fst-italic fw-bold">delete</span> in the text input field.</p>
                <div style={{textAlign:"center"}}>
                  <input placeholder="delete" value={inputValue} onChange={(e) => setInputValue(e.target.value)}  style={{ marginBottom: "10px", width: "240px", padding: "5px" }}/>
                </div>
                <div>
                  {!isConfirmedDeleting && (
                    <div className="submit-container" style={{padding:"0px 10px", margin: "20px 0px"}}>
                      <div className="cancel" style={{ height: "30px",borderRadius:"8px",fontSize:"16px" }} onClick={() => setIsOpen(false)}>Cancel</div>
                      <div className="submit" style={{ height: "30px",borderRadius:"8px",fontSize:"16px" }}>Ok</div>
                    </div>
                  )}
                  {isConfirmedDeleting && (
                    <div className="submit-container" style={{padding:"0px 10px", margin: "20px 0px"}}>
                      <div className="cancel" style={{ height: "30px",borderRadius:"8px",fontSize:"16px" }} onClick={() => setIsOpen(false)}>Cancel</div>
                      <div className="submit" style={{ height: "30px",borderRadius:"8px",fontSize:"16px" }} onClick={() => okClick()}>Ok</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
         </div>
      )}
      </div>
    );
  } 

  function navigateToDeviceSettingsClick(id) {
    navigate("/device/" + id);
  }  

  function deleteDeviceClick() {
    setIsOpen(true);
  } 

  async function okClick() {
    setLoading(true);
    let device = {
        deviceId: selectedItemId
    };
    try {
       await infrastructureService.delete("Device", device);
       AppAlert.success("Device was deleted successfully");
    } catch (error) {
       AppAlert.error("Device deletion error");
    } finally {
        setLoading(false);
    }
    setDevices([]);
    loadDevices();
    loadStatisticSummary();
    setIsOpen(false);
  } 

  const handleConfirmChanged = async() => {
    const token = localStorage.getItem("access_token");
        const userId = getUserIdFromToken(token);
        if (!userId) {
          return;
        }
  
        try {
          const data = await infrastructureService.get("User", { userId });
          setPhoneNumber(data.phoneNumber);
          setPhoneNumberConfirmed(data.phoneNumberConfirmed);
        } catch (error) {
          console.error("Error fetching user:", error);
        } finally {
          setLoading(false);
        }
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 600) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    };
    
    handleResize();
    
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getPages = () => {
    const pages = [];
    const delta = 1; 
  
    for (let i = 1; i <= Math.min(2, totalPages); i++) {
      pages.push(i);
    }
  
    const start = Math.max(currentPage - delta, 3);
    const end = Math.min(currentPage + delta, totalPages - 2);

    if (start > 3) pages.push("left-ellipsis");

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (end < totalPages - 2) pages.push("right-ellipsis");

    if (totalPages > 3) {
      for (let i = Math.max(totalPages - 1, end + 1); i <= totalPages; i++) {
        pages.push(i);
      }
    }

    return [...new Set(pages)]; 
  }

  return (
    <div>
      <div className="div-menu">
        <div onClick={() => setOpen(true)} className="menu-button">
          <label><svg width="30" height="30" fill="currentColor" viewBox="0 0 16 16">
            <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 
                                         0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
          </svg></label>
        </div>
        {open && (
          <div className="modal">
             <div className="modal-content">
               <div className="col-span-12 h-full rounded-2xl bg-white/70 p-4 shadow-sm ring-1 ring-gray-100 md:col-span-3 lg:col-span-2 modal-content-div">
                <div className="close-modal" onClick={() => setOpen(false)}>
                  <MenuIcon/>
                </div>
                <div className="space-y-6">
                  <div>
                      <p className="px-2 text-sm font-semibold text-gray-600">Overview</p>
                      <div className="mt-2 space-y-1">
                         <Link className="link-item" to="/">
                           <label className="link-lab"> 
                              <CompaniesMenuIcon/> Companies                               
                              <label className="label-float-end">{availableCompanies}</label>
                           </label>
                         </Link>
                         <Link className="link-item" to="/users">
                           <label className="link-lab">
                              <UsersMenuIcon/> Users
                              <label className="label-float-end">{availableUsers}</label>
                           </label>
                         </Link>
                         <Link className="link-item-selected" to="/devices">
                           <label className="link-lab">
                               <DevicesMenuIcon/> Devices                               
                              <label className="label-float-end">{availableDevices}</label>
                           </label>
                         </Link>
                      </div>
                      <hr/>
                  </div>
                  
                   <div className="pt-2">
                        <p className="px-2 text-sm font-semibold text-gray-600">Notifications</p>
                        <div className="mt-2 space-y-1">                        
                         <Link className="link-item" to="/emails">
                           <label className="link-lab">
                              <EmailsMenuIcon/> Emails
                               <label className="label-float-end">{emailNotifications}</label>
                           </label>
                         </Link>
                         <Link className="link-item" to="/messages">
                           <label className="link-lab">
                              <MessagesMenuIcon/> Messages
                              <label className="label-float-end">{messagesNotifications}</label>
                           </label>
                         </Link>
                         <Link className="link-item" to="/phoneCalls">
                           <label className="link-lab">
                              <PhoneNumberMenuIcon/> Phone Calls
                              <label className="label-float-end">{phoneCallsNotifications}</label>
                           </label>
                         </Link>
                        </div>
                        <hr/>
                    </div>
                    
                  <div className="mx-2 h-px bg-gray-200"/></div>
                </div>
             </div>
          </div>
        )}
      </div>

       <div className='devices'>
          <div className='filter'>
             <div>
               <div className='div-input-filter-c'>
                <div className="group">
                  <svg className="icon" aria-hidden="true" viewBox="0 0 16 16">
                       <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 
                       1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
                  </svg>
                  <input placeholder="Filter by keywords" type="search" className="input-filter" onChange={handleChange} onBlur={handleBlur} value={filter}/>
                </div>
               </div>
                <svg className="icon-add" aria-hidden="true" viewBox="0 0 16 16" onClick={() => navigateToDeviceSettingsClick("new")}>
                    <path d="M8 1a.5.5 0 0 1 .5.5V7.5H14a.5.5 0 0 1 0 1H8.5V14a.5.5 0 0 1-1 0V8.5H2a.5.5 0 0 1 0-1h5.5V1.5A.5.5 0 0 1 8 1Z" />
                </svg>
             </div>
             {userRole !== undefined && userRole === Global_Admin_Role && (<div className='div-input-checkbox-d'>
                <div className="select-company">
                  <Select options={companyOptions} isSearchable={true} placeholder="Please select a company" styles={customStyles}
                          value={companyOptions.find((opt) => opt.value === String(companyId)) || null} onChange={handleCompanyChange}/>
                </div>
             </div>)}
          </div>     

          {loading && (<div>Loading...</div>)}    
         
          <div className="pagination-div pagination-div-margin">
                <nav aria-label="pagination">
                   <ul className="pagination">
                    <li>
                      <button disabled={currentPage === 1} onClick={() => handlePageChange(1)}
                          style={{padding: "5px 10px", borderRadius: "15px", border: "1px solid #ccc",
                                  color: "#333", fontWeight: "normal", backgroundColor: currentPage === 1 ? "#e6e6e6ff" : "white" }}>
                         &laquo;
                      </button>
                    </li>
                    {getPages().map((page, index) => page === "left-ellipsis" || page === "right-ellipsis" ? (
                        <li key={index}>…</li>) : (<li key={index}>
                          <button onClick={() => handlePageChange(page)}
                            style={{ margin: "0", padding: "5px 10px", borderRadius: "15px", border: "1px solid #ccc",
                                     backgroundColor: currentPage === page ? "#333" : "white", color: currentPage === page ? "white" : "#333", 
                                     fontWeight: currentPage === page ? "bold" : "normal", cursor: "pointer"}}>
                            {page}
                          </button>
                        </li>
                     ))}
                     <li>
                      <button disabled={currentPage === totalPages} onClick={() => handlePageChange(totalPages)}
                           style={{padding: "5px 10px", borderRadius: "15px", border: "1px solid #ccc",
                                   color: "#333", fontWeight: "normal", backgroundColor: currentPage === totalPages ? "#e6e6e6ff" : "white" }}>
                        &raquo;
                      </button>
                    </li>
                   </ul>
                </nav>
               </div>

         {!loading && (<div className="card-list" style={{minHeight:"500px"}}>
           {devices != null && devices.length > 0 ? (devices.map((card) => (
               <Device key={card.id} id={card.id} name={card.name} description={card.description} nextGeneration={card.nextGeneration} companyid={card.companyId} 
                      activeAlarmCount={card.activeAlarmCount} isOnline={card.isOnline} serialNumber={card.serialNumber}/>))) : (
              <p>No devices available.</p>
            )}
         </div>)}
         
{isOpenCompanies && (
  <div style={{ position:"fixed", top:0, left:0, right:0, bottom:0, display:"flex", justifyContent:"center", alignItems:"center", zIndex:1000, background:"rgba(0,0,0,0.3)" }}>
    <div style={{ backgroundColor:"white", borderRadius:"8px", width:"100%", maxWidth:"550px", maxHeight:"80vh", display:"flex", flexDirection:"column", boxShadow:"0 5px 15px rgba(0,0,0,0.3)" }}>
      
      <div style={{ background:"rgb(236,236,236)", padding:"10px" }}>
        <h2 style={{ margin:0, padding:"13px 0" }}>Move device</h2>
      </div>

      <div style={{ padding:"10px", overflowY:"auto", flex:1 }}>
        {loading && <div>Loading...</div>}

        {!loading && (
          <>
            {companies?.length > 0 ? companies.map((company) => (
              <div key={`company-${company.id}`} style={{ border:"1px solid rgb(230,230,230)", borderRadius:"10px", cursor:"pointer", padding:"10px", display:"flex", alignItems:"center", gap:"10px", marginBottom:"8px" }} onClick={() => setTargetCompanyId(Number(company.id))}>
                <input type="radio" name="company" checked={targetCompanyId === Number(company.id)} onChange={() => setTargetCompanyId(Number(company.id))} style={{ margin:0 }} />
                <span>{company.name}</span>
              </div>
            )) : <p>No companies available.</p>}
          </>
        )}
      </div>

      <div className="submit-container" style={{ padding:"10px", borderTop:"1px solid #eee" }}>
        <div className="cancel" style={{ height:"30px", borderRadius:"8px", fontSize:"16px" }} onClick={() => setIsOpenCompanies(false)}>Cancel</div>
        <div className="submit" style={{ height:"30px", borderRadius:"8px", fontSize:"16px" }} onClick={saveClick}>Save</div>
      </div>

    </div>
  </div>
)}

       </div>
    </div>
  );
}

export default Devices;